import { Steps } from "antd";
const { Step } = Steps;

const CartSteps = ({ current = 1, options = {} }) => {
  return (
    <Steps
      style={{ textAlign: "left" }}
      size="small"
      type="navigation"
      current={current > 0 ? current - 1 : 0}
      initial={0}
      {...options}
    >
      <Step title="Košík" status={current > 1 ? "finish" : ""} />
      <Step title="Kontaktné informácie" status={current > 2 ? "finish" : ""} />
      <Step title="Doprava a platba" status={current > 3 ? "finish" : ""} />
    </Steps>
  );
};

export default CartSteps;
